<template>
    <span @click="copyToClipboard" class="btn btn-sm" style="align-items: center;">
        <slot>
            <svg class='svg-icon' viewbox='0 0 16 16'>
                <path fill-rule="evenodd"
                    d="M7.5 4h6A1.5 1.5 0 0 1 15 5.5v8a1.5 1.5 0 0 1-1.5 1.5h-6A1.5 1.5 0 0 1 6 13.5v-8A1.5 1.5 0 0 1 7.5 4zm0 1a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-8a.5.5 0 0 0-.5-.5h-6zm.5 5h3v1H8v-1zm0 2h4v1H8v-1zm0-4h5v1H8V8zm0-2h2v1H8V6zM3 9h2v1H3V9zm0-2h2v1H3V7zm0-2h2v1H3V5zm0-2h2v1H3V3zm7 0H9v-.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5H5v1H2.5A1.5 1.5 0 0 1 1 10.5v-8A1.5 1.5 0 0 1 2.5 1h6A1.5 1.5 0 0 1 10 2.5V3z" />
            </svg>
        </slot>
    </span>
</template>

<script>
    export default {
        data() {
            return {
                notify: false,
                snackbar: null,
                textArea: null,
            }
        },
        props: {
            dataToCopy: {
                type: String,
                default: '',
            },
            onSuccessText: {
                type: String,
                default: '✅ Copied To Clipboard'
            },
            onErrorText: {
                type: String,
                default: '❌ Unable to copy to clipboard'
            }
        },
        methods: {
            /**
             * Is it ios or some other thingy?
             *
             * @return {boolean}
             */
            isOS() {
                let platform = navigator?.userAgentData?.platform || navigator?.platform
                return !!platform && /iPad|iPhone|iPod/.test(platform);
            },

            /**
             * Create the text area and populate it
             *
             * @return {void}
             */
            createTextArea(text) {
                this.textArea = document.createElement('textarea');
                this.textArea.readOnly = true;
                this.textArea.contentEditable = true;
                this.textArea.value = text;
                this.textArea.style.position = "absolute";
                this.textArea.setAttribute(this.$options._scopeId, "");
                this.textArea.style.left = "-9999px";


                this.$el.appendChild(this.textArea);
                // select the data in the text area
                if (this.isOS()) {
                    var range, selection;
                    range = document.createRange();
                    range.selectNodeContents(this.textArea);
                    selection = window.getSelection();
                    selection.removeAllRanges();
                    selection.addRange(range);
                    textArea.setSelectionRange(0, 999999);
                } else {
                    this.textArea.select();
                }
            },

            /**
             * Copy the data to clipboard and snack bar away if it worked
             */
            copyToClipboard() {
                this.createTextArea(this.dataToCopy);

                var result = document.execCommand('copy');
                this.showSnackbar(result);

                this.$el.removeChild(this.textArea);
            },

            showSnackbar(success = true) {
                this.snackbar.innerText = success ? this.onSuccessText : this.onErrorText;
                this.snackbar.classList.add('show', success ? 'alert-success' : 'alert-danger');
                setTimeout(() => {
                    this.snackbar.classList.remove('show')
                }, 2000);
            }
        },
        mounted() {
            this.snackbar = document.createElement('div');
            this.snackbar.setAttribute(this.$options._scopeId, "");
            this.snackbar.classList.add('alert', 'fadeInUp', 'notification')
            document.body.appendChild(this.snackbar);

            /**
             * This was causing doubling issues when multiple were on a page
             * The method seems to be valid still, but could be changed to work correctly.
             */
            // document.addEventListener('copy', (event) => {
            // event.preventDefault()
            // if (event.clipboardData) {
            //     event.clipboardData.setData('text/plain', this.dataToCopy);
            // } else if (window.clipboardData) {
            //     window.clipboardData.setData('Text', this.dataToCopy);
            // }
            // });
        },
    };

</script>

<style lang="scss" scoped>
    .svg-icon {
        height: 1rem;
        width: 1rem;
        fill: currentColor;
    }

    .notification {
        position: fixed;
        top: -500px;
        right: 24px;
        transition: 500ms ease-in-out;
        z-index: 9999;
    }

    .notification.show {
        top: 24px;
    }

    .notification-wrapper {
        display: flex;
    }

</style>
